import React from 'react';
import { Facebook, Instagram, Phone } from 'lucide-react';
export function UtilityBar() {
  return <div className="hidden md:block w-full bg-ivory border-b border-sand/50 py-2 px-6 lg:px-12 z-50 relative" data-id="element-316">
      <div className="max-w-[1400px] mx-auto flex justify-between items-center text-xs tracking-wider text-charcoal" data-id="element-317">
        <div className="flex items-center space-x-6" data-id="element-318">
          <span className="flex items-center" data-id="element-319">
            <Phone className="w-3 h-3 mr-2" data-id="element-320" /> OFFICE 602.309.8888
          </span>
          <span className="flex items-center" data-id="element-321">
            <Phone className="w-3 h-3 mr-2" data-id="element-322" /> CELL 480.215.2324
          </span>
        </div>
        <div className="flex items-center space-x-4" data-id="element-323">
          <a href="#" className="hover:text-terracotta transition-colors" aria-label="Facebook" data-id="element-324">
            <Facebook className="w-4 h-4" strokeWidth={1.5} data-id="element-325" />
          </a>
          <a href="#" className="hover:text-terracotta transition-colors" aria-label="Instagram" data-id="element-326">
            <Instagram className="w-4 h-4" strokeWidth={1.5} data-id="element-327" />
          </a>
        </div>
      </div>
    </div>;
}